/* ★ CAPTION TikTok / FB PADA KAD (2026-09-27).
 *
 * Peraturan user 27 Sept:
 *   · LALAI: caption FB = caption TikTok — kedua-dua platform post caption yang sama.
 *   · Pelanggan ubah kotak "Facebook Caption" dalam Edit prompts + Save → FB guna teks itu.
 *   · Pelanggan SENGAJA kosongkan kotak itu + Save → FB post TANPA caption.
 *   · Caption TikTok dijana semula (Generate / Agent Saya / Retry) → pilihan FB sendiri
 *     dibuang, FB kembali ikut caption TikTok yang baharu.
 *
 * Data dalam prompts.setN (kedua-duanya INLINE dalam doc utama — productService.js):
 *   captionFb        — teks FB sendiri ('' / tiada = tiada pilihan sendiri)
 *   captionFbKosong  — true = pelanggan sengaja mahu FB tanpa caption
 * Tiada kedua-duanya = ikut caption TikTok. Caption yang dihantar ke robot: `captionUntukFb`
 * (rancanganKalendar.js) — SATU takrifan, dipakai kedua-dua laluan Run FB.
 * Selamat secara lalai: laluan yang tercicir `captionFbKosong` membuat FB kembali post
 * caption TikTok — tidak pernah post kosong secara senyap.
 *
 * Suis TikTok/FB pada kad = PAPARAN SAHAJA (components/SuisCaptionKad.jsx).
 */
import { captionUntukFb, fbKosongSengaja } from './rancanganKalendar';

/* Pelanggan memang memilih FB tanpa caption — SATU takrifan, dalam rancanganKalendar.js
   (bersama `captionUntukFb` yang robot pakai). */
export { fbKosongSengaja };

/* Teks kotak Facebook Caption (kad + modal) = keputusan `captionUntukFb` (takrifan robot),
   KECUALI caption FB sendiri dipulangkan TANPA trim — modal menyunting nilai ini secara
   langsung, dan trim akan menelan ruang yang sedang ditaip di hujung ayat. */
export function teksKotakFb(set) {
    const fb = String(set?.captionFb || '');
    return fb.trim() ? fb : captionUntukFb(set);
}

/* Teks kotak caption kad ikut suis TikTok/FB + sama ada FB sengaja dikosongkan. */
export function captionKad(set, fb) {
    if (!fb) return { teks: String(set?.captionTiktok || ''), kosongSengaja: false };
    return { teks: teksKotakFb(set), kosongSengaja: fbKosongSengaja(set) };
}

/* Set tanpa pilihan caption FB sendiri → FB kembali ikut caption TikTok.
   Kunci DIBUANG, bukan dikosongkan: kedua-dua medan INLINE dalam doc utama, yang
   ditulis penuh (saveProducts = set tanpa merge; updateProduct = ganti peta `prompts`),
   jadi kunci yang hilang memang terpadam di pangkalan data. */
export function tanpaCaptionFbSendiri(set) {
    if (!set || typeof set !== 'object') return set;
    const baki = { ...set };
    delete baki.captionFb;
    delete baki.captionFbKosong;
    return baki;
}

/* Kotak "Facebook Caption" dalam Edit prompts ditaip → set baharu.
   · teks SAMA dengan caption TikTok semasa → tiada pilihan sendiri (terus ikut TikTok,
     termasuk bila caption TikTok diubah kemudian)
   · kosong → FB sengaja tanpa caption
   · lain → caption FB sendiri */
export function setDenganKotakFb(set, teks) {
    const asas = tanpaCaptionFbSendiri(set || {});
    const v = String(teks ?? '');
    if (v === String(set?.captionTiktok || '')) return asas;
    if (!v.trim()) return { ...asas, captionFb: '', captionFbKosong: true };
    return { ...asas, captionFb: v };
}

/* Label kepala kotak caption kad. Suis di sebelahnya sudah menyebut platform, jadi
   lalainya "Caption". Label TikTok yang diubah pelanggan dalam tetapan Space
   (`labels.captionTiktok`) tetap dihormati dalam mod TikTok — label itu milik caption
   TikTok, jadi mod FB kembali "Caption". */
export function labelCaptionKad(labelSpace, fb, T) {
    const suai = String(labelSpace || '').trim();
    if (!fb && suai && suai !== 'TikTok Caption') return suai;
    return T('ws.caption.label', 'Caption');
}
